import { Link } from '@chakra-ui/react';

interface Props {
  isStoryExpired: boolean;
  contentLink?: string;
  children: React.ReactNode;
}

export const ContentPreviewWrapper = ({
  isStoryExpired,
  contentLink,
  children,
}: Props) => {
  if (isStoryExpired) {
    return <>{children}</>;
  }
  return (
    <Link
      href={contentLink}
      isExternal
      borderRadius="lg"
      overflow="hidden"
      _hover={{ textDecoration: 'none' }}
    >
      {children}
    </Link>
  );
};
